import { createContext, ReactNode, useContext } from 'react';
import { usePersistedTeamSelection } from '../hooks/usePersistedTeamSelection';
import { useGetTeamsQuery } from '../hooks';

type SelectedUnitContextProps = {
  selectedTeamId: number;
  setSelectedTeamId: (selectedTeamId: number) => void;
};

export type RouterMetadataProps = {
  children?: ReactNode;
};

const SelectedUnitContext = createContext<SelectedUnitContextProps>({
  selectedTeamId: 0,
  setSelectedTeamId: () => {},
});

export const SelectedUnitContextProvider = ({
  children,
}: RouterMetadataProps) => {
  const { data: teams = [] } = useGetTeamsQuery();
  const { selectedTeamId, setSelectedTeamId } = usePersistedTeamSelection(teams);

  return (
    <SelectedUnitContext.Provider
      value={{
        selectedTeamId,
        setSelectedTeamId,
      }}
    >
      {children}
    </SelectedUnitContext.Provider>
  );
};

export const useSelectedUnitContext = function () {
  const context = useContext(SelectedUnitContext);
  if (context === undefined) {
    throw new Error(
      'useSelectedUnitContext must be used within a UseSelectedUnitContextProvider.',
    );
  }
  return context;
};
